module.exports = __webpack_public_path__ + "static/media/FaktPro-Normal.f7da5fea.ttf";